import "./VehiclesCreateFooter.scss";

import { useVehiclesCreateForm } from "../../../../../hooks/useVehiclesCreateForm";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const VehiclesCreateFooter = () => {
    const { handleSend } = useVehiclesCreateForm();

    return (
        <div className={"vehicles-create-footer"}>
            <Button title={"Добавить"} onClick={handleSend}/>
        </div>
    )
}

export default VehiclesCreateFooter;
